import React from 'react';
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { getBaseSlugFromPath } from 'utils'

const MeetingReportingItem = props => {
    const {
        item,
        match
    } = props

    if(!item || !item.project){
        return null
    }
    
    return (
        <li className="list-item">
            <Link 
                to={getBaseSlugFromPath(match.url)+'/projects/'+item.project.slug+'/meetings?meeting='+item.item.id}
                className={'team-item'}
            >
                <div className="user-meta">
                    <span>
                        { item.start_date }
                    </span>
                    <span className={!item.project ? 'empty' : null}>
                        { item.project ? item.project.name : `(No project)`}
                    </span>
                    <span className={!item.location ? 'empty' : null}>
                        { item.location ? item.location : `(No location)` }
                    </span>
                    <span className={!item.stakeholders ? 'empty' : null}>
                        { item.stakeholders ? item.stakeholders : `(No organisations)` }
                    </span>
                    <span className={!item.purposes ? 'empty' : null}>
                        { item.purposes ? item.purposes : `(No purposes)`}
                    </span>
                    <span className={!item.contact_type ? 'empty' : null}>
                        { item.contact_type ? item.contact_type.name : `(No contact type)`}
                    </span>
                </div>
            </Link>
        </li>
    )
};

export default withRouter(MeetingReportingItem)